import { Box, Text, VStack, HStack } from "@chakra-ui/layout";
import { Image, Radio, RadioGroup } from "@chakra-ui/react";

import { MollieMethod } from "doxecure-commons/lib/mollieTypes";
import { Nullable } from "foundation-ts/types";

import MollieCardForm from "./MollieCardForm";
import MollieMandateForm from "./MollieMandateForm";

interface ConfirmationStepProps {
    paymentMethods: Nullable<MollieMethod[]>;
    selectedPaymentMethod: string;
    planLabel: string;
    companyName: string;
    mollieProfileId: string;
    testMode: boolean;
    onMethodChange: (id: string) => void;
    onCardSuccess: (token: string) => Promise<void>;
    onMandateSuccess: (consumerAccount: string, consumerName: string) => Promise<void>;
}

export default function ConfirmationStep(props: ConfirmationStepProps) {
    const {
        paymentMethods,
        selectedPaymentMethod,
        planLabel,
        companyName,
        mollieProfileId,
        testMode,
        onMethodChange,
        onCardSuccess,
        onMandateSuccess,
    } = props;

    return (
        <VStack spacing={6} align="stretch">
            <RadioGroup value={selectedPaymentMethod} onChange={onMethodChange}>
                <HStack spacing={4} align="stretch">
                    {paymentMethods?.map((method: MollieMethod) => (
                        <Box
                            key={method.id}
                            flex="1"
                            p={4}
                            borderWidth={2}
                            borderRadius="md"
                            borderColor={selectedPaymentMethod === method.id ? "blue.500" : "gray.200"}
                            bg={selectedPaymentMethod === method.id ? "blue.50" : "transparent"}
                            color={selectedPaymentMethod === method.id ? "black" : "gray.100"}
                            cursor="pointer"
                            _hover={{ borderColor: "blue.300" }}
                            transition="all 0.2s"
                            onClick={() => onMethodChange(method.id)}
                        >
                            <HStack spacing={4} justifyContent="center">
                                <Radio value={method.id} />
                                <Image src={method.image.svg} alt={method.description} maxH="40px" objectFit="contain" />
                                <Text fontWeight="bold">{method.id === 'creditcard' ? "Carte bancaire" : (method.id === 'banktransfer' ? "Virement SEPA" : "Pay By Bank")}</Text>
                            </HStack>
                        </Box>
                    ))}
                </HStack>
            </RadioGroup>

            {selectedPaymentMethod && (
                <Box key={selectedPaymentMethod}>
                    {selectedPaymentMethod === "creditcard" && (
                        <MollieCardForm
                            key="creditcard"
                            profileId={mollieProfileId}
                            planLabel={planLabel}
                            testMode={testMode}
                            onSuccess={onCardSuccess}
                        />
                    )}
                    {selectedPaymentMethod === "banktransfer" && (
                        <MollieMandateForm
                            key="banktransfer"
                            companyName={companyName}
                            planLabel={planLabel}
                            onSuccess={onMandateSuccess}
                        />
                    )}
                </Box>
            )}
        </VStack>
    );
}